import { lazy } from 'react';
import { RouteObject } from 'react-router';
import { ROUTES } from './constants';

const MaturityCalibration = lazy(() => import('./pages/maturity-calibration'));
const MaturityConcretePresses = lazy(() => import('./pages/maturity-concrete-presses'));

const NotFound = lazy(() => import('./pages/not-found'));
const MaintenanceMode = lazy(() => import('./pages/maintenance-mode'));
const Home = lazy(() => import('./pages/home'));
const Project = lazy(() => import('./pages/project'));
const AddOrEditPour = lazy(() => import('./pages/add-or-edit-pour'));
const AddHub = lazy(() => import('./pages/add-hub'));
const UpsertDevice = lazy(() => import('./pages/upsert-device'));
const Sensor = lazy(() => import('./pages/sensor'));
const Sensors = lazy(() => import('./pages/pour-sensors'));
const Settings = lazy(() => import('./pages/settings'));
const EditSensor = lazy(() => import('./pages/edit-sensor'));

const routes: RouteObject[] = [
  {
    path: ROUTES.HOME,
    element: <Home />,
  },
  {
    path: ROUTES.PROJECT,
    element: <Project />,
  },
  {
    path: ROUTES.ADD_POUR,
    element: <AddOrEditPour />,
  },
  {
    path: ROUTES.EDIT_POUR,
    element: <AddOrEditPour isEdit />,
  },
  {
    path: ROUTES.ADD_HUB,
    element: <AddHub />,
  },
  {
    path: ROUTES.UPSERT_DEVICE,
    element: <UpsertDevice/>,
  },
  {
    path: ROUTES.SENSORS,
    element: <Sensors />,
  },
  { path: ROUTES.SENSOR, element: <Sensor /> },
  { path: ROUTES.SETTINGS, element: <Settings /> },
  { path: ROUTES.EDIT_SENSOR, element: <EditSensor /> },

  { path: ROUTES.MATURITY_CALIBRATION, element: <MaturityCalibration /> },
  { path: ROUTES.MATURITY_CONCRETE_PRESSES, element: <MaturityConcretePresses /> },
  {
    path: '*',
    element: <NotFound />,
  },
  {
    path: ROUTES.MAINTENANCE_MODE,
    element: <MaintenanceMode />,
  },
];
export default routes;
